import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const WeightPage = lazy(() => import("./WeightPage"));

const WeightPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <WeightPage />
    </Suspense>
  );
};

export default WeightPageLazy;
